import { IComponentOptions } from "angular";

import { ConnectorService } from "@gtmhub/connectors/connectorService";
import { DataSourceService } from "@gtmhub/datasources";
import { WorkdayUserProvisioningService } from "../workday-user-provisioning-service";
import { IConnection, ICreateConnectorParams } from "@gtmhub/connectors/models";
import { IDataSource } from "@gtmhub/datasources/models/models";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IWorkdayEntityTableMapping } from "../models";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";

export class WorkdayConnectorFormCtrl {
  workdayConnection: ICreateConnectorParams;
  indicators;

  static $inject = ["$scope", "ConnectorService", "DataSourceService", "WorkdayUserProvisioningService", "UIErrorHandlingService"];

  constructor(
    private $scope: IExtendedRootScopeService,
    private connectorService: ConnectorService,
    private dataSourceService: DataSourceService,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {}

  connect(): void {
    this.indicators.saving = true;
    this.workdayConnection.dataSourceBlueprintName = "workday";
    this.workdayConnection.syncSchedule = "hourly";

    let connectorId: string;
    this.connectorService
      .createConnection(this.workdayConnection)
      .then((connector: IConnection) => {
        connectorId = connector.id;
        return this.workdayUserProvisioningService.getEntityTableMappings();
      })
      .then((entityMappings: IWorkdayEntityTableMapping[]) =>
        // create and map all data sources for Workday connector automatically:
        this.dataSourceService.bulkCreateDataSources({
          datasources: entityMappings.map(
            (entityMap) =>
              <IDataSource>{
                name: `${entityMap.entityName}_${connectorId}`,
                namespace: entityMap.namespace,
                key: entityMap.remoteEntityName,
                connectorId: connectorId,
                // default value for bulk sync:
                syncSchedule: "manual",
                typeName: null,
              }
          ),
        })
      )
      // save already created connector and each data source id in Workday settings:
      .then((dataSources: { items: IDataSource[] }) =>
        this.workdayUserProvisioningService.updateWorkdaySettings({
          dataSourceSettings: {
            connectorId,
            dataSourceIds: dataSources.items.map((dataSource) => dataSource.id),
          },
        })
      )
      .then(() => {
        this.$scope.$root.$broadcast("progressStepChanged");
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
        this.indicators.saving = false;
      });
  }
}

export const WorkdayConnectorFormComponent: IComponentOptions = {
  bindings: {
    indicators: "<",
  },

  controller: WorkdayConnectorFormCtrl,
  templateUrl: require("./workday-connector-form.component.jade"),
};
